import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Getting Started',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
